// extracted by mini-css-extract-plugin
module.exports = {"root":"Main-root-2564150e67d0efa0fece25e5a850159b"};